'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useCallback } from 'react';
const ToastContext = createContext(undefined);
export function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([]);
    const showToast = useCallback((toast) => {
        const id = Math.random().toString(36).substring(2, 9);
        const newToast = {
            id,
            duration: 5000, // Default 5 seconds
            ...toast,
        };
        setToasts(prev => [...prev, newToast]);
        // Auto-hide toast after duration
        if (newToast.duration && newToast.duration > 0) {
            setTimeout(() => {
                hideToast(id);
            }, newToast.duration);
        }
    }, []);
    const hideToast = useCallback((id) => {
        setToasts(prev => prev.filter(toast => toast.id !== id));
    }, []);
    const showSuccess = useCallback((title, message) => {
        showToast({ type: 'success', title, message });
    }, [showToast]);
    const showError = useCallback((title, message) => {
        showToast({ type: 'error', title, message, duration: 7000 }); // Longer for errors
    }, [showToast]);
    const showWarning = useCallback((title, message) => {
        showToast({ type: 'warning', title, message });
    }, [showToast]);
    const showInfo = useCallback((title, message) => {
        showToast({ type: 'info', title, message });
    }, [showToast]);
    const value = {
        toasts,
        showToast,
        hideToast,
        showSuccess,
        showError,
        showWarning,
        showInfo,
    };
    return (_jsx(ToastContext.Provider, { value: value, children: children }));
}
export function useToast() {
    const context = useContext(ToastContext);
    if (context === undefined) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
}
